import React from 'react';
import Tabs from './Tabs'
import SearchByName from './SearchByName'
import SearchByMeaning from './SearchByMeaning'

const SearchByHeader = (props) => {    
    return (
        <React.Fragment>
            <div className="blk blk-header">        
                <Tabs label={props.complabel}>
                    <div label={props.namelink}>
                        <div className="blk blk-searchbycat">
                            <SearchByName                                
                                {...props}
                                searchtype="searchbyname"
                            />     
                        </div>          
                    </div>
                    <div label={props.meaninglink}>
                        <div className="blk blk-searchbycat">
                            <SearchByMeaning                                
                                {...props}
                                searchtype="searchbymeaning"
                            />
                        </div>
                    </div>            
                </Tabs>
            </div>
        </React.Fragment>
    )
}

export default SearchByHeader;